import { IconDefinition } from '@ant-design/icons-angular';
import {
  DownOutline, UpOutline, LeftOutline, RightOutline,
  ArrowUpOutline, ArrowDownOutline, ArrowLeftOutline, ArrowRightOutline,
  CaretRightOutline, CaretDownOutline, CaretUpOutline,
  DoubleLeftOutline, DoubleRightOutline, VerticalAlignTopOutline, VerticalAlignBottomOutline,
  MenuOutline, MenuFoldOutline, MenuUnfoldOutline, EllipsisOutline, MoreOutline, BarsOutline,
  PlusOutline, MinusOutline, CloseOutline, CheckOutline,
  EditOutline, DeleteOutline, SaveOutline, CopyOutline, SearchOutline,
  ReloadOutline, SyncOutline, DownloadOutline, UploadOutline, FilterOutline,
  SettingOutline, RedoOutline, UndoOutline, SendOutline, ScanOutline, ClearOutline,
  CheckCircleOutline, CloseCircleOutline, ExclamationCircleOutline,
  InfoCircleOutline, QuestionCircleOutline, WarningOutline, LoadingOutline,
  MinusCircleOutline, PlusCircleOutline, ClockCircleOutline, StopOutline,
  CheckCircleFill, CloseCircleFill, ExclamationCircleFill, InfoCircleFill, WarningFill,
  UserOutline, UserAddOutline, UserDeleteOutline, TeamOutline,
  BellOutline, MailOutline, HomeOutline, FolderOutline, FolderOpenOutline,
  FileOutline, FileTextOutline, FilePdfOutline, FileImageOutline,
  CalendarOutline, EyeOutline, EyeInvisibleOutline,
  LockOutline, UnlockOutline, KeyOutline,
  StarOutline, HeartOutline, LikeOutline, TagOutline, FlagOutline,
  CameraOutline, PictureOutline, DesktopOutline, MobileOutline, LaptopOutline,
  DatabaseOutline, CloudUploadOutline, CloudDownloadOutline, CloudServerOutline,
  ApiOutline, ToolOutline, DashboardOutline, AppstoreOutline, TableOutline,
  ThunderboltOutline, GlobalOutline, EnvironmentOutline, PhoneOutline, PrinterOutline,
  LoginOutline, LogoutOutline, CrownOutline, RobotOutline, BulbOutline,
  FireOutline, TrophyOutline, RocketOutline, ControlOutline, SlidersOutline,
} from '@ant-design/icons-angular/icons';

export const icons: IconDefinition[] = [
  DownOutline, UpOutline, LeftOutline, RightOutline,
  ArrowUpOutline, ArrowDownOutline, ArrowLeftOutline, ArrowRightOutline,
  CaretRightOutline, CaretDownOutline, CaretUpOutline,
  DoubleLeftOutline, DoubleRightOutline, VerticalAlignTopOutline, VerticalAlignBottomOutline,
  MenuOutline, MenuFoldOutline, MenuUnfoldOutline, EllipsisOutline, MoreOutline, BarsOutline,
  PlusOutline, MinusOutline, CloseOutline, CheckOutline,
  EditOutline, DeleteOutline, SaveOutline, CopyOutline, SearchOutline,
  ReloadOutline, SyncOutline, DownloadOutline, UploadOutline, FilterOutline,
  SettingOutline, RedoOutline, UndoOutline, SendOutline, ScanOutline, ClearOutline,
  CheckCircleOutline, CloseCircleOutline, ExclamationCircleOutline,
  InfoCircleOutline, QuestionCircleOutline, WarningOutline, LoadingOutline,
  MinusCircleOutline, PlusCircleOutline, ClockCircleOutline, StopOutline,
  CheckCircleFill, CloseCircleFill, ExclamationCircleFill, InfoCircleFill, WarningFill,
  UserOutline, UserAddOutline, UserDeleteOutline, TeamOutline,
  BellOutline, MailOutline, HomeOutline, FolderOutline, FolderOpenOutline,
  FileOutline, FileTextOutline, FilePdfOutline, FileImageOutline,
  CalendarOutline, EyeOutline, EyeInvisibleOutline,
  LockOutline, UnlockOutline, KeyOutline,
  StarOutline, HeartOutline, LikeOutline, TagOutline, FlagOutline,
  CameraOutline, PictureOutline, DesktopOutline, MobileOutline, LaptopOutline,
  DatabaseOutline, CloudUploadOutline, CloudDownloadOutline, CloudServerOutline,
  ApiOutline, ToolOutline, DashboardOutline, AppstoreOutline, TableOutline,
  ThunderboltOutline, GlobalOutline, EnvironmentOutline, PhoneOutline, PrinterOutline,
  LoginOutline, LogoutOutline, CrownOutline, RobotOutline, BulbOutline,
  FireOutline, TrophyOutline, RocketOutline, ControlOutline, SlidersOutline,
];
